import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { api, mediaUrl } from "../lib/api";
import { ArrowLeft } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api
      .get(`/site/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setError(true));
  }, [slug]);

  if (error) {
    return (
      <div className="min-h-screen bg-ivory">
        <Header />
        <main className="container-prose pt-32 pb-24 text-center">
          <p className="overline">404</p>
          <h1 className="h1-display mt-3 text-5xl text-ink">Essay not found.</h1>
          <Link to="/#blog" className="mt-6 inline-flex items-center gap-2 text-forest underline-offset-4 hover:underline">
            <ArrowLeft size={14} /> Back to insights
          </Link>
        </main>
        <Footer />
      </div>
    );
  }
  if (!post) return null;

  return (
    <div className="bg-ivory">
      <Header />
      <article className="container-prose pt-28 sm:pt-36 pb-16 max-w-3xl">
        <Link to="/#blog" className="inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.22em] text-ink/60 hover:text-forest">
          <ArrowLeft size={14} /> Insights
        </Link>
        <p className="overline mt-8">
          {new Date(post.created_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}
        </p>
        <h1 className="h1-display mt-4 text-4xl sm:text-6xl text-ink">{post.title}</h1>
        {post.excerpt && (
          <p className="mt-6 text-xl sm:text-2xl text-ink/80 italic" style={{ fontFamily: '"Cormorant Garamond", serif' }}>
            {post.excerpt}
          </p>
        )}
        {post.cover_image && (
          <div className="mt-10 aspect-[16/9] bg-ink/5 overflow-hidden">
            <img src={mediaUrl(post.cover_image)} alt="" className="w-full h-full object-cover" />
          </div>
        )}
        <div className="prose prose-lg mt-10 max-w-none body-prose text-ink/85 whitespace-pre-wrap leading-relaxed">
          {post.content}
        </div>
      </article>
      <Footer />
    </div>
  );
}
